import { useConfirmationDialog } from 'components/common/ConfirmationDialog/useConfirmationDialog';
import type { ReactNode } from 'react';
import { useEffect } from 'react';

interface ConfirmDialogProps {
  title: string;
  message: ReactNode;
  onConfirm: (confirmed: boolean) => void;
  isDeleteAction?: boolean;
}

export const ConfirmDialog = ({
  onConfirm,
  title,
  message,
  isDeleteAction,
}: ConfirmDialogProps) => {
  const { showConfirmation } = useConfirmationDialog();
  useEffect(() => {
    showConfirmation({
      title,
      message,
      confirmButtonLabel: 'Yes',
      confirmButtonColor: isDeleteAction ? 'error' : 'primary',
    }).then(onConfirm);
  }, []);
  return null;
};
